"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Raster = exports.ColorIndexFnType = void 0;
const ColorService_1 = require("@granular/gds-ux-components/lib/services/ColorService");
const sortedLastIndex_1 = __importDefault(require("lodash/sortedLastIndex"));
var ColorIndexFnType;
(function (ColorIndexFnType) {
    ColorIndexFnType["KEYED"] = "keyed";
    ColorIndexFnType["RANGE"] = "range";
})(ColorIndexFnType = exports.ColorIndexFnType || (exports.ColorIndexFnType = {}));
class Raster {
    constructor(data, bounds, colorRange, options) {
        this.data = data;
        this.colorRange = [];
        this.ranges = [];
        this.colorIndexFnType = ColorIndexFnType.RANGE;
        this.noDataValues = [];
        this.bounds = bounds;
        this.colorRange = colorRange;
        this.options = options;
        this.colors = ColorService_1.colorService.getDiscreteRange({
            palette: colorRange,
            stops: options.colorStops || colorRange.length,
            format: "rgb",
        });
    }
    get values() {
        return this.data[0];
    }
    get orderedValues() {
        return this.values.filter((value) => !isNaN(value)).sort((a, b) => a - b);
    }
    get height() {
        return this.data.height;
    }
    get width() {
        return this.data.width;
    }
    updateColors() {
        this.colors = ColorService_1.colorService.getDiscreteRange({
            palette: this.colorRange,
            stops: this.options.colorStops || this.colorRange.length,
            format: "rgb",
        });
    }
    getColorIndexFromRange(value) {
        const index = (0, sortedLastIndex_1.default)(this.ranges, value);
        const lastIndex = this.ranges.length - 1;
        if (index > lastIndex) {
            return lastIndex;
        }
        return index;
    }
    getKeyedColorIndex(value) {
        let index = this.ranges.indexOf(value);
        const colorsLength = this.colors.length;
        while (index >= colorsLength) {
            index = index % colorsLength;
        }
        return index;
    }
    getColorIndex(value) {
        switch (this.colorIndexFnType) {
            case ColorIndexFnType.KEYED:
                return this.getKeyedColorIndex(value);
            case ColorIndexFnType.RANGE:
            default:
                return this.getColorIndexFromRange(value);
        }
    }
    isNoDataValue(value) {
        return Number.isNaN(value) || this.noDataValues.includes(value);
    }
    computeImagedata() {
        const image = new ImageData(this.width, this.height);
        let pixel = 0;
        this.values.forEach((value) => {
            // if no data exists for this value, set the pixel to transparent
            if (this.isNoDataValue(value)) {
                image.data[pixel + 3] = 0;
            }
            else {
                let colorIndex = this.getColorIndex(value);
                if (colorIndex === -1) {
                    colorIndex = this.ranges.length - 1;
                }
                const rgb = this.colors[colorIndex];
                image.data[pixel] = rgb.r; // r
                image.data[pixel + 1] = rgb.g; // g
                image.data[pixel + 2] = rgb.b; // b
                image.data[pixel + 3] = 255; // a
            }
            pixel += 4; // each pixel represented by 4 array values, rgba
        });
        return image;
    }
}
exports.Raster = Raster;
